import React from 'react';
import { motion } from 'framer-motion';
import { useAlgo } from '../hooks/useAlgo';
import Alert from './Alert';
import { useRaffles } from '../hooks/useRaffles';
import Spinner from './Spinner';
import config from '../config';
import RafflePreview from './RafflePreview';

function RaffleList({ raffles }) {
  const { address } = useAlgo();

  const sortedRaffles = [...raffles]
    .sort((a, b) => {
      const aTime = new Date(a.endDate).getTime();
      const bTime = new Date(b.endDate).getTime();
      return aTime - bTime;
    })
    .sort((a, b) => {
      // sort winners to bottom

      if (a.winner && !b.winner) {
        return 1;
      }
      if (!a.winner && b.winner) {
        return -1;
      }
      return 0;
    });

  return (
    <div>
      <div className='mx-auto space-y-10 max-w-[90rem] px-6'>
        {sortedRaffles?.length > 0 ? (
          <div
            className={`grid w-full grid-cols-1 gap-10 md:grid-cols-2 ${
              sortedRaffles.length === 1
                ? 'lg:grid-cols-1 max-w-md mx-auto'
                : sortedRaffles.length === 2
                ? 'lg:grid-cols-2 max-w-3xl mx-auto'
                : 'lg:grid-cols-4'
            }`}
          >
            {sortedRaffles.map((raffle, index) => (
              <motion.div key={raffle?.id}>
                <RafflePreview raffle={raffle} />
              </motion.div>
            ))}
          </div>
        ) : (
          <div className='max-w-md col-span-1 col-start-2 mx-auto space-y-10'>
            <Alert type='danger'>
              <div>No active raffles found</div>
            </Alert>
            <p className='text-[24px] text-center max-w-sm mx-auto'>
              <a href={config.discord} target='_blank' rel='noreferrer' className='font-bold text-theme-1'>
                Join Discord
              </a>{' '}
              for more information on the next one!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RaffleList;
